import { useMemo } from 'react';

import { useEndpoint } from '../../../../api/hooks/endpoint/useEndpoint';
import { useMenuCategories } from '../../../../api/hooks/menu-categories/useMenuCategories';
import {
  getMenuItemsColumnDefinition,
  MENU_ITEMS_TABS
} from '../../../../schema/menu/items/menu-items.schema';
import { flattenObject } from '../../../../utils/tools';
import { EntityTable } from '../../../common/entity-table/EntityTable';

export const MenuItemTable = () => {
  const menuItemsQuery = useEndpoint('/menu/items', 'menuItems');
  const menusQuery = useEndpoint('/menus', 'menus');
  const menuCategoriesQuery = useMenuCategories();

  const menuItems = useMemo(() => {
    return {
      ...menuItemsQuery,
      data: menuItemsQuery.data?.map((menuItem) => flattenObject(menuItem, 'nutrition'))
    };
  }, [menuItemsQuery]);

  const filteredCategories = useMemo(
    () => (menuCategoriesQuery?.data ?? []).filter((item) => item.filterEnabled),
    [menuCategoriesQuery]
  );

  const menuItemsTabs = useMemo(
    () => MENU_ITEMS_TABS(menusQuery?.data ?? [], filteredCategories),
    [menusQuery, filteredCategories]
  );

  return (
    <EntityTable
      query={menuItems}
      getColumnDefinition={getMenuItemsColumnDefinition}
      entityTabs={menuItemsTabs}
      entityName="Menu Item"
      canExport={false}
      jsonKeys={['nutrition']}
    />
  );
};
